var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.473 7.146-5.046.587a.488.488 0 0 0-.404.344c-.06.194 0 .396.135.523 1.5 1.436 3.754 3.585 3.754 3.585-.002 0-.619 3.126-1.029 5.212a.518.518 0 0 0 .188.509c.156.12.357.121.515.028C7.353 16.88 10 15.298 10 15.298l4.41 2.637c.161.092.362.09.519-.03a.515.515 0 0 0 .186-.507l-1.026-5.213 3.755-3.582c.134-.131.193-.333.134-.526a.483.483 0 0 0-.402-.342c-2.02-.237-5.048-.589-5.048-.589l-2.091-4.85A.484.484 0 0 0 9.999 2a.477.477 0 0 0-.434.295c-.838 1.94-2.092 4.851-2.092 4.851z",
    fill: "#FCBD38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.1474f6cc1aa98a6b168febb348a7ffa2.svg";
export { ForwardRef as ReactComponent };